module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./axios/index.js
// module id = 163
// module chunks = 72